// Default min/max highlight palette (green/red) matches the cell-voltage
// legend; cards whose legend uses different colors (e.g. blue for min
// temperature) pass their own flagStyles so tile and legend always agree.
const DEFAULT_FLAG_STYLES = {
  min: { bg: 'bg-[#daf5ed]', text: 'text-[#006c4d]' },
  max: { bg: 'bg-[#fde9e7]', text: 'text-[#d03b3b]' },
}

const ValueGrid = ({ items, legend, columns = 4, flagStyles = DEFAULT_FLAG_STYLES }) => (
  <div className="flex flex-col gap-3">
    <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
      {items.map((item, i) => (
        <div
          key={i}
          className={`rounded px-2 py-1.5 flex flex-col gap-0.5 ${flagStyles[item.flag]?.bg ?? 'bg-[#f2f4f7]'}`}
        >
          <span className="text-xs font-normal text-[#616a79]">{item.label}</span>
          <span className={`text-sm font-medium ${flagStyles[item.flag]?.text ?? 'text-[#272d37]'}`}>
            {item.value}
          </span>
        </div>
      ))}
    </div>
    <div className="flex items-center justify-center gap-4">
      {legend.map((l) => (
        <div key={l.label} className="flex items-center gap-1.5">
          <span className="w-3 h-0.5 rounded-full" style={{ backgroundColor: l.color }} />
          <span className="text-xs font-normal text-[#616a79]">{l.label}</span>
        </div>
      ))}
    </div>
  </div>
)

export default ValueGrid
